export default __webpack_public_path__ + "static/media/setion02_kv02.42ca1eb9.png";